function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M46.922,15H41v1.141a.86.86,0,0,1-.859.859H24.859A.86.86,0,0,1,24,16.141V15H18.078A2.052,2.052,0,0,0,16,17.026V51.974A2.052,2.052,0,0,0,18.078,54H46.922A2.052,2.052,0,0,0,49,51.974V17.026A2.052,2.052,0,0,0,46.922,15Z",
    className: "stroke",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.984,13H35v-.372a2.529,2.529,0,0,0-1.88-2.488A2.491,2.491,0,0,0,30,12.511V13H25.016A1.016,1.016,0,0,0,24,14.016v1.968A1.016,1.016,0,0,0,25.016,17H39.984A1.016,1.016,0,0,0,41,15.984V14.016A1.016,1.016,0,0,0,39.984,13Z",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,24H43",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 23 20 24 23 20",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,32H43",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 31 20 32 23 28",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,40H43",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 39 20 40 23 36",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,48H43",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 47 20 48 23 44",
    className: "stroke",
    style: {
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.e6219ac25ef5e0fc11ad9a22af10a798.svg";
export { ForwardRef as ReactComponent };